/**
 * @file: MaintenanceServicePlanDetailType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum MaintenanceServicePlanDetailType {
  InspectionSubject = 'inspection_subject',
  ConstructionJob = 'construction_job',
  PendingIssue = 'pending_issue',
  SolvedPendingIssue = 'solved_pending_issue',
  FaultLikeSubject = 'fault_like_subject',
  Custom = 'custom',
  InsuranceExpiry = 'insurance_expiry',
}

export const MaintenanceServicePlanDetailTypeValueSet = new Set([
  MaintenanceServicePlanDetailType.InspectionSubject,
  MaintenanceServicePlanDetailType.ConstructionJob,
  MaintenanceServicePlanDetailType.PendingIssue,
  MaintenanceServicePlanDetailType.SolvedPendingIssue,
  MaintenanceServicePlanDetailType.FaultLikeSubject,
  MaintenanceServicePlanDetailType.Custom,
  MaintenanceServicePlanDetailType.InsuranceExpiry,
]);
